import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { PublicAccountsProvider } from './context/public-accounts-context';
import { PublicAccountsComponent } from './public-accounts-component';

export function PublicAccountsFactory() {
  return (
    <BaseLayoutFactory>
      <PublicAccountsProvider>
        <PublicAccountsComponent />
      </PublicAccountsProvider>
    </BaseLayoutFactory>
  );
}
